import { tw } from "@careinfo/tailwind";
import { CellContext, ColumnDef } from "@tanstack/react-table";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import APIS from "../../constant/Endpoint";
import Button from "../../shared/Button";
import DataTable from "../../shared/DataTable";
import ActionCell from "../../shared/DataTable/ActionCell";
import NACell from "../../shared/DataTable/NACell";
import Modal from "../../shared/Modal";
import { INavigation } from "../../types/interface";

interface Props {
  showDeleteModal: boolean;
  setShowDeleteModal: Dispatch<SetStateAction<boolean>>;
  handleDelete: (id: string) => Promise<void>;
  isDeletingNavigation: boolean;
}

export default function NavigationList({
  showDeleteModal,
  setShowDeleteModal,
  handleDelete,
  isDeletingNavigation,
}: Props) {
  const [toDelete, setToDelete] = useState<string | null>(null);

  const handleDeleteClick = (id: string) => {
    setToDelete(id);
    setShowDeleteModal(true);
  };

  const handleModalClose = () => {
    setToDelete(null);
    setShowDeleteModal(false);
  };

  const columns: ColumnDef<INavigation>[] = [
    {
      accessorKey: "name",
      header: "Name",
      cell: NACell,
    },
    {
      accessorKey: "path",
      header: "Path",
      cell: NACell,
    },
    {
      accessorKey: "is_external",
      header: "Type",
      cell: (props: CellContext<any, boolean>) => (
        <p>{props.getValue() ? "External" : "Internal"}</p>
      ),
    },
    {
      accessorKey: "order",
      header: "Order",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: (props: CellContext<any, string>) => (
        <ActionCell
          {...props}
          editPath={`edit/${props.getValue()}`}
          handleDeleteClick={handleDeleteClick}
        />
      ),
    },
  ];

  useEffect(() => {
    if (!showDeleteModal) setToDelete(null);
  }, [showDeleteModal]);

  return (
    <div>
      <DataTable
        url={`${APIS.NAVIGATION}`}
        queryKey="navigaion"
        columns={columns}
        addNewPagePath="create"
        tableName="Navigation"
      />
      <Modal
        isOpen={showDeleteModal}
        setIsOpen={setShowDeleteModal}
        closeModal={handleModalClose}
        title="Are you sure, want to delete this component?"
        width="20rem"
      >
        <Modal.Caution>
          <p className={tw`py-2`}>
            <span className={tw`font-bold text-primary text-center`}>
              Note:{"    "}
            </span>
            This action can not be undone
          </p>
        </Modal.Caution>
        <div className={tw`grid grid-cols-2 gap-x-4 items-center`}>
          <Button
            label="Yes, Delete"
            type="button"
            onClick={() => handleDelete(toDelete)}
            isLoading={isDeletingNavigation}
            disabled={isDeletingNavigation || !toDelete}
          />
          <button
            type="button"
            onClick={() => {
              setToDelete(null);
              setShowDeleteModal(false);
            }}
            className={tw`w-full bg-gray-400 text-white px-4 py-2 rounded-md focus:outline-none`}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
}
